import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Popover} from "react-bootstrap";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {infoToast} from "../../../utils/toasts";

class ShareUrlPopover extends Component {
    static propTypes = {
        url: PropTypes.string.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {url, close, ...props} = this.props;
        return (
            <Popover close={() => this.close()} {...props}>
                <div className="m-b-2">
                    <input type="text" className="form-control" readOnly={true}
                           value={url}
                           onClick={event => event.target.select()}/>
                </div>
                <div className="clearfix">
                    <button type="button" className="btn btn-default btn-3d m-r-2"
                            onClick={() => close()}>
                        Закрыть
                    </button>
                    <CopyToClipboard text={url}
                                     onCopy={() => this.onCopyUrl()}>
                        <button type="button" className="btn btn-success btn-3d pull-right">
                            Копировать
                        </button>
                    </CopyToClipboard>

                </div>
            </Popover>
        );
    }

    onCopyUrl() {
        const {close} = this.props;

        infoToast('Ссылка успешно скопирована в буфер обмена');
        close();
    }
}

export default ShareUrlPopover;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/popovers/ShareUrlPopover.js